import React from 'react';
import * as yup from 'yup';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import { internationalPhoneRegex, getPhoneRegex } from 'Utils/regex/RegexHelper';
import { useFormikContext } from 'formik';
type VoxpayPhoneInputProps = {
  isDisabled?: boolean;
  withValidation?: boolean;
  fieldName: string;
};
export const VoxpayPhoneInput = ({
  isDisabled,
  fieldName,
  withValidation = true,
}: VoxpayPhoneInputProps) => {
  const formik = useFormikContext();
  const appContext = useAppContext();
  const phoneRegex = getPhoneRegex(appContext.locale);
  const validatePhone = yup
    .string()
    .matches(phoneRegex, t('booking.partners.linkPayment.sms.invalidNumber'))
    .matches(
      internationalPhoneRegex,
      t('booking.partners.linkPayment.sms.wrongFormatInternational'),
    )
    .required();
  return (
    <FormikInput
      isDisabled={isDisabled}
      name={fieldName}
      onChange={(e) => formik.setFieldValue(fieldName, e.target.value.trim())}
      label={t('common.form.labels.mobilePhoneNumber')}
      type="tel"
      validate={withValidation ? validatePhone : undefined}
    />
  );
};
